import React, {useState, useEffect, useRef, useLayoutEffect} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import WebConfig from "../../src/middlewares/WebConfig";
import responseHandler from "../../src/responseHandler";
//import { setupSignalRConnection } from '../../src/middlewares/signalr';
import {
  setupSignalRConnection,
  SignalRConnectionStatus_NotConnected,
  SignalRConnectionStatus_Connected,
  SignalRConnectionStatus_Disconnected, SignalRConnectionStatus_Connecting, SignalRConnectionStatus_Reconnecting,
} from "../../src/middlewares/signalrAspNet";
import {MTable} from "../../src/components/Shared";
import {CheckBoxOutlineBlank, DeviceUnknown, Phonelink, PhonelinkOff, Router} from "@material-ui/icons";
import {InputField} from "../../src/components/FormElements";
import {AddCaseNoteRequest} from "../../src/apis/api";

const ESmallTestPage = ({
                          signalrToken,
                          initSignalR,
                        }) => {
  const [currentMessage, setCurrentMessage] = useState("Awaiting first message");
  const [currentMessageExport, setCurrentMessageExport] = useState("");
  const [currentMessageExportItems, setCurrentMessageExportItems] = useState([]);
  const [caseNoteRequest, setCaseNoteRequest] = useState<AddCaseNoteRequest>({
    noteBody: "hello world"
  });
  const onReceiveMessageToAll = (message) => {
    setCurrentMessage(message);
  };
  let currentMessageExportAll = "";
  let currentMessageExportItemsAll = [];
  const onReceiveCaseExportProgressUpdate = (caseExportProgressUpdate) => {
    const message = `${currentMessageExportAll}\n${caseExportProgressUpdate.ControlNumber} - ${caseExportProgressUpdate.UpdateMessage}`;
    currentMessageExportAll = message;
    setCurrentMessageExport(message);

    currentMessageExportItemsAll = [caseExportProgressUpdate, ...currentMessageExportItemsAll];
    setCurrentMessageExportItems(currentMessageExportItemsAll);
  };
  const signalrConnectionHub = useRef(null);

  const [signalRSignalState, signalRSignalStateSet] = useState({
    oldState: SignalRConnectionStatus_Disconnected,
    newState: SignalRConnectionStatus_NotConnected,
  });
  const signalRStateRef = useRef({
    oldState: SignalRConnectionStatus_Disconnected,
    newState: SignalRConnectionStatus_NotConnected,
  });

  useLayoutEffect(() => {
    //window.setTimeout(startSignalRConnection, 5000);
    startSignalRConnection();
    return () => {
      // Disconnect SignalR on component unmount
      const localSignalRHub = signalrConnectionHub.current;
      signalrConnectionHub.current = null;
      localSignalRHub && localSignalRHub.stop(true, true);
    };
  }, []);

  const signalR_ReconnectDelay = useRef(1000);
  const signalRStateChanged = (e, data) => {
    signalRSignalStateSet(data);
    signalRStateRef.current = data;
    if (data.newState === SignalRConnectionStatus_Connected) {
      signalR_ReconnectDelay.current = 1000;
    }
    // Re-open the connection if connection is lost while the C/A window is open
    if (signalrConnectionHub.current && data.newState === SignalRConnectionStatus_Disconnected) {
      window.setTimeout(() => {
        signalrConnectionHub.current.start();
      }, signalR_ReconnectDelay.current);
      signalR_ReconnectDelay.current += 1000;
    }
  };

  function startSignalRConnection() {
    if (signalrConnectionHub.current && signalRStateRef.current.newState === SignalRConnectionStatus_Disconnected) {
      // Reconnect SignalR if the connection is disconnected
      signalrConnectionHub.current = null;
    }
    if (!signalrConnectionHub.current) {
      // Create a new SignalR connection
      let connectionFunc = setupSignalRConnection(
          WebConfig.signalrConnectionRoot, "CaseExportHub",
          {
            SSO: signalrToken
          },
          {
            //ReceiveEventOnCase: onReceiveEventOnCase,
            //ReceiveMessageToAll: onReceiveMessageToAll,
            ReceiveCaseExportProgressUpdate: onReceiveCaseExportProgressUpdate,
          },
          () => {
            return signalrToken;
          });
      signalrConnectionHub.current = initSignalR(connectionFunc)
          .then((v) => {
            if (!v.events.onStateChanged) {
              v.events.onStateChanged = [];
            }
            v.events.onStateChanged.push(signalRStateChanged);
            v.reconnectWindow = Math.max(v.reconnectWindow, 120000); // Try reconnecting for at least 120 seconds
            v.serverTimeoutInMilliseconds = Math.max(v.serverTimeoutInMilliseconds, v.reconnectWindow * 2, 240000); // Try reconnecting for at least 120 seconds
            signalrConnectionHub.current = v;
          });
    }
  }

  const SignalRSignalStateIcon = (value) => {
    switch (value) {
      case SignalRConnectionStatus_Connecting:
        return <Router titleAccess={"Connecting"} fontSize={"small"}/>;
      case SignalRConnectionStatus_Connected:
        return <Phonelink titleAccess={"Connected"} fontSize={"small"}/>;
      case SignalRConnectionStatus_Reconnecting:
        return <Router titleAccess={"Reconnecting"} fontSize={"small"}/>;
      case SignalRConnectionStatus_Disconnected:
        return <PhonelinkOff titleAccess={"Disconnected"} fontSize={"small"}/>;
      case SignalRConnectionStatus_NotConnected:
        return <CheckBoxOutlineBlank titleAccess={"Not Connected"} fontSize={"small"}/>;
    }
    return <DeviceUnknown titleAccess={`Unknown: ${value}`} fontSize={"small"}/>;
  };
  const [signalrStateIcon, signalrStateIconSet] = useState(SignalRSignalStateIcon(SignalRConnectionStatus_NotConnected));
  useEffect(() => {
    signalrStateIconSet(SignalRSignalStateIcon(signalRSignalState.newState));
  }, [signalRSignalState]);

  const [exportUuidToAdd, setExportUuidToAdd] = useState("ShowMeAllTheExports");
  const exportUuidToAddOnChange = (inputText) => {
    setExportUuidToAdd(inputText);
  };
  const subscribeExport = () => {
    // Example of subscribing to another export
    const exportUuid = [exportUuidToAdd];
    signalrConnectionHub.current.createHubProxy("CaseExportHub")
        .invoke("subscribeExports", exportUuid);
  };

  const columns = [
    /*
      name, the column name to show in the grid header
      className, optional classname for a column
      dataSource, provides data for the grid (either a string of a property name to pull off of the dataSource prop or a function that will be invoked with the entire row passed in from dataSource)
      width, optional width of the column,
      addDepthWhitespace, optional boolean, if using depthProperty prop this will render whitespace before the text with a width based on how deep this row is
     */
    {name: "Date", dataSource: "CreateDateUtc"}
    , {name: "Control #", dataSource: "ControlNumber"}
    , {name: "Export Code", dataSource: "ExportCode"}
    , {name: "Message", dataSource: "UpdateMessage"},
  ];
  return (
      <>
        <div>Incoming message: {currentMessage}</div>
        <div>
          <InputField id="exportUuid" checkError={exportUuidToAddOnChange} value={exportUuidToAdd} input="text" meta="Export uuid to add" hintText="Enter an export uuid to watch"/>
          <button onClick={subscribeExport}>Watch Export</button>
        </div>
        <MTable columnDefinitions={columns} data={currentMessageExportItems}/>
        <div>Export progress: <span>{signalrStateIcon}</span><br/>
          <pre>{currentMessageExport}</pre>
        </div>
      </>
  );
};

ESmallTestPage.propTypes = {
  caseForms: PropTypes.array,
  signalrToken: PropTypes.string,
  initSignalR: PropTypes.func,
};

const mapStateToProps = (state) => ({
  caseForms: state.caseForms.caseFormsList,
  signalrToken: state.user.profile.token,
});

const mapDispatchToProps = (dispatch) => ({
  initSignalR(signalrConnectionHub) {
    return dispatch(signalrConnectionHub);
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ESmallTestPage);
